<style scoped>

</style>

<template>
  <div
    v-if="shouldShowSection"
    class="section-resource-group"
  >
    <div>
      <div v-if="!sectionHere.canDisable || (sectionHere.canDisable && sectionHere.isEnabled)">
        <div v-if="sectionHere.sectionResources && sectionHere.sectionResources.length"
        >
          <div
            v-for="(resource) in sectionHere.sectionResources"
            :key="resource.id"
            style="position: relative"
          >
            <TemplateSectionResourceTable
              :section="sectionHere"
              :resource="resource"
              :showResourceSelector="showResourceSelector"
            />
          </div>
          <div class="SectionTable">
            <TemplateSectionRow emptyRow/>
          </div>
        </div>

        <div
          v-if="sectionHere.isAddingResource"
          style="position: relative;"
        >
          <div style="position: relative; overflow: hidden;">
            <TemplateSectionJaggedBorderTop/>
            <TemplateSectionBackground/>
            <DialogResourceAdd
              :section="sectionHere"
              @onCloseDialogResourceAdd="onCloseDialogResourceAdd"
            />
            <div class="SectionTable">
              <TemplateSectionJaggedBorderBottom/>
              <TemplateSectionRow emptyRow/>
            </div>
          </div>
        </div>

        <div
          v-if="canAddResource && !sectionHere.isAddingResource && !isEditingResources"
          class="SectionTable"
        >
          <TemplateSectionRow emptyRow/>
          <TemplateSectionRow emptyRow/>
          <TemplateSectionRow emptyRow/>

          <div
            class="step-actions"
            style="position: absolute; top: 0px; left: 50px;"
          >
            <v-btn
              data-qa="section__add_resource_btn"
              x-small
              color="primary"
              style="background-color: #fff;"
              @click="addSectionResource(sectionHere)"
            >
              <v-icon style="font-size: 14px; padding-right: 5px;">mdi-plus</v-icon>
              {{ translate(sectionHere.addResourceLabel) }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DialogResourceAdd from '@/components/dialogs/DialogResourceAdd.vue';
import TemplateSectionResourceTable from '@/components/sections/TemplateSection/TemplateSectionResourceTable.vue';
import TemplateSectionRow from '@/components/sections/TemplateSection/TemplateSectionResourceTableRow.vue';
import TemplateSectionBackground from '@/components/sections/TemplateSection/TemplateSectionBackground.vue';
import TemplateSectionJaggedBorderTop
  from '@/components/sections/TemplateSection/TemplateSectionJaggedBorderTop';
import TemplateSectionJaggedBorderBottom from '@/components/sections/TemplateSection/TemplateSectionJaggedBorderBottom.vue';
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    TemplateSectionJaggedBorderTop,
    DialogResourceAdd,
    TemplateSectionResourceTable,
    TemplateSectionRow,
    TemplateSectionBackground,
    TemplateSectionJaggedBorderBottom,
  },
  mixins: [Mixin],
  name: 'TemplateSectionCenter',
  props: {
    sectionId: String,
    section: Object,
    showResourceSelector: Boolean,
  },
  computed: {
    sectionHere() {
      return this.sectionId ? this.getSectionById(this.sectionId) : this.section;
    },
    shouldShowSection() {
      return true;
      // const envSections = ['section_currency', 'section_taxes', 'section_depreciation'];
      // return this.sectionHere.isInitialized || this.sectionHere.isAddingResource || this.sectionHere.isEditingResources || envSections.includes(this.sectionHere.id);
    },
    isEditingResources() {
      return this.sectionHere.sectionResources.some((resource) => resource.isEdited);
    },
    canAddResource() {
      const notAllowedToAddResourceToSectionIds = ['section_currency', 'section_taxes'];
      return !notAllowedToAddResourceToSectionIds.includes(this.sectionHere.id);
    },
    // headerRows() {
    //   const rows = [];
    //   const subSectionIds = ['section_currency', 'section_taxes', 'section_depreciation'];
    //   let className = subSectionIds.includes(this.sectionHere.id) ? 'row-subsection-header' : 'row-section-header';
    //   if (!this.sectionHere.isEnabled) {
    //     className += ' section--disabled';
    //   }
    //   const units = subSectionIds.includes(this.sectionHere.id) ? '' : 'ui_assumptions_columns__units';
    //   rows.push({
    //     className,
    //     content: this.sectionHere.title,
    //     units,
    //     zeroPeriod: '"0"',
    //   });
    //
    //   return rows;
    // },
  },
  methods: {
    onCloseDialogResourceAdd() {
      this.sectionHere.isAddingResource = false;
    },
  },
};
</script>
